import { useContext, useState, useEffect } from 'react';
import { t } from 'i18next';
import { Box, Button, Typography } from '@mui/material';
import { FEATURE_TAGS } from '../utils/FeatureTags';
import ApiManager from '../../libs/ApiManager';
import Search from '../components/Search';
import Header, { VIEWS } from '../utils/Header';
import CircularIndeterminate from '../utils/Progress';
import ErrorMessageContext from '../context/ErrorMessageContext';
import { ReactComponent as SearchIcon } from '../../images/search.svg';

import '../../styles/CategoryContainer.scss';

export default function CategoryContainer ({
  locale,
  onLoad = () => {},
  onSearchClick,
  onSignOut,
  onClick,
  onClose
}) {
  const { onError }  = useContext(ErrorMessageContext);
  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchResults, setSearchResults] = useState(null);

  useEffect(() => {
    async function fetchCategories () {
      setIsLoading(true);
      try {
        const data = await ApiManager.listCategories(locale);
        const commonCategories = data.filter((item) => item.name === FEATURE_TAGS.category.common);
        const newCategories = data.filter((item) => item.name !== FEATURE_TAGS.category.common);
        newCategories.forEach(category => {
          const description = category.description.replace('\r', '');
          const array = description.split('\n');
          const icon = array.find(item => item.indexOf('icon=') === 0);
          if (icon) {
            category.icon = icon.replace(/^icon=/, '');
          }
        });
        setCategories(newCategories);
        await onLoad(newCategories, commonCategories);
      } catch (err) {
        onError(err);
      }
      setIsLoading(false);
    };
    if (locale) {
      fetchCategories();
    }
  }, [locale]);

  return <Box className='category-container'>
    <Header title={t('header')} view={VIEWS.CATEGORY} onSignOut={onSignOut} onBack={onClose} />
    <Box className='category-body'>
      <CircularIndeterminate show={isLoading} />
      <Box className='categories'>
        <Typography className='title'>{t('title')}</Typography>
        {/* <Search onChange={setSearchResults} /> */}
        {
          Array.isArray(searchResults) && searchResults.length > 0 ? <Box className='search-results'>
              {searchResults.map((result, index) => <Button
                key={`${result.id}-${index}`}
                className='search-item'
                color='normal'
                onClick={onSearchClick}>
                  <SearchIcon className='search-icon' />
                  <div className='search-title'>{result.title}</div>
                </Button>)}
            </Box> : <>
              <Typography className='sub-title'>{t('select_category')}</Typography>
              {
                categories.map(item => <Button key={item.id} className='category' color='normal' onClick={() => onClick(item)}>
                  {item.icon ? <img className='icon' src={item.icon} alt='icon' /> : <div className='icon' />}
                  {item.name}
                </Button>)
              }
            </>
        }
      </Box>
    </Box>
  </Box>
}